import * as Ct from "ldlj"
import { ReactNode } from "react"
import { Text } from "../components/Commons/Text"
import styled from "styled-components"

export const defaultRichTextElements = {
  boldBlack: (chunks: ReactNode[]) => (
    <Ct.Text
      text={chunks as unknown as string}
      textStyle={{ color: "navy", fontWeight: 700 }}
    />
  ),
  boldColored: (chunks: ReactNode[]) => (
    <Ct.Text
      text={chunks as unknown as string}
      textStyle={{ color: "cornflower", fontWeight: 500 }}
    />
  ),
  bolderColored: (chunks: ReactNode[]) => (
    <Ct.Text
      text={chunks as unknown as string}
      textStyle={{ color: "cornflower", fontWeight: 700 }}
    />
  ),
  boldColoredLink: (chunks: ReactNode[]) => (
    <ClickableText
      text={chunks as unknown as string}
      textStyle={{ color: "cornflower", fontWeight: 500 }}
    />
  ),
  grayColoredLink: (chunks: ReactNode[]) => (
    <Ct.Text
      text={chunks as unknown as string}
      textStyle={{ color: "disabledGrey", fontWeight: 500 }}
    />
  ),
  boldColoredTitle: (chunks: ReactNode[]) => (
    <Ct.Text
      text={chunks as unknown as string}
      textStyle={{
        color: "cornflower",
        lineHeight: 3,
        fontFamily: "Poppins",
        fontWeight: 600,
        fontSize: 3,
      }}
    />
  ),
  boldColoredLarger: (chunks: ReactNode[]) => (
    <Ct.Text
      text={chunks as unknown as string}
      textStyle={{
        color: "cornflower",
        lineHeight: 3,
        fontWeight: 700,
        fontSize: 2.25,
      }}
    />
  ),
  boldItalicGrey: (chunks: ReactNode[]) => (
    <Ct.Text
      text={chunks as unknown as string}
      textStyle={{
        fontFamily: "Roboto",
        fontWeight: 700,
        fontStyle: "italic",
        fontSize: 2,
        color: "slateGrey",
      }}
    />
  ),
  italic: (chunks: ReactNode[]) => (
    <Ct.Text
      text={chunks as unknown as string}
      textStyle={{
        fontFamily: "Roboto",
        fontWeight: 500,
        fontStyle: "italic",
        fontSize: 2,
        color: "steelBlue",
      }}
    />
  ),
  boldSmallGrey: (chunks: ReactNode[]) => (
    <Ct.Text
      text={chunks as unknown as string}
      textStyle={{
        fontFamily: "Roboto",
        fontWeight: 500,
        fontStyle: "italic",
        fontSize: 2,
        color: "lightBlueGrey",
      }}
    />
  ),
  italicColored: (chunks: ReactNode[]) => (
    <Text
      text={chunks as unknown as string}
      textStyle={{
        fontFamily: "Roboto",
        fontStyle: "italic",
        color: "steelBlue",
      }}
    />
  ),
  boldUnderlineColored: (chunks: ReactNode[]) => (
    <Ct.Text
      text={chunks as unknown as string}
      textStyle={{
        color: "cornflower",
        fontWeight: 500,
        underline: true,
        fontSize: 2.25,
      }}
    />
  ),
  underlineColored: (chunks: ReactNode[]) => (
    <Ct.Text
      text={chunks as unknown as string}
      textStyle={{
        color: "cornflower",
        underline: true,
      }}
    />
  ),
  b: (chunks: ReactNode[]) => <b>{chunks}</b>,
  b2: (chunks: ReactNode[]) => <b>{chunks}</b>,
  b3: (chunks: ReactNode[]) => <b>{chunks}</b>,
  b700: (chunks: ReactNode[]) => (
    <span style={{ fontWeight: 700 }}>{chunks}</span>
  ),
  br: () => <br />,
  p: (chunks: ReactNode[]) => <p>{chunks}</p>,
  i: (chunks: ReactNode[]) => <i>{chunks}</i>,
  dot: (chunks: ReactNode[]) => <b>&#8226;</b>,
  nbsp: (chunks: ReactNode[]) => <span>&nbsp;</span>,
}

export const ClickableText = styled(Ct.Text)`
  cursor: pointer;
`
